import { Grid, Card, CardContent, Box, Stack, Typography, LinearProgress } from '@mui/material';
import {
  Send as SendIcon,
  MarkEmailUnread as UnreadIcon,
  DraftsOutlined as ReadIcon,
  TrendingUp as RateIcon,
} from '@mui/icons-material';

const MetricCard = ({ label, value, icon: Icon, color, bgcolor, subtitle, helper }) => (
  <Card
    elevation={2}
    sx={{
      height: '100%',
      border: '1px solid',
      borderColor: 'divider',
      transition: 'all 0.3s ease',
      '&:hover': {
        boxShadow: 4,
        transform: 'translateY(-4px)',
        borderColor: color,
      },
    }}
  >
    <CardContent sx={{ p: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
        <Box>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: '0.75rem', fontWeight: 500 }}
          >
            {label}
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 'bold',
              color: 'text.primary',
              fontSize: '1.5rem',
              mt: 0.5,
            }}
          >
            {value}
          </Typography>
        </Box>
        <Box
          sx={{
            backgroundColor: bgcolor,
            borderRadius: '50%',
            p: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 36,
            minHeight: 36,
          }}
        >
          <Icon sx={{ color, fontSize: '1.2rem' }} />
        </Box>
      </Box>

      {subtitle && (
        <Typography variant="caption" color="text.secondary">
          {subtitle}
        </Typography>
      )}

      {helper}
    </CardContent>
  </Card>
);

const MetricsBoard = ({ metrics, isLoading }) => {
  const readRate = Math.round((metrics?.read_ratio || 0) * 100);

  return (
    <Box sx={{ bgcolor: 'background.paper', p: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
        <MetricCard
          label="Total enviadas"
          value={metrics?.total ?? 0}
          icon={SendIcon}
          color="#2196f3"
          bgcolor="#e3f2fd"
          subtitle="Notificaciones enviadas"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <MetricCard
          label="No leídas"
          value={metrics?.unread ?? 0}
          icon={UnreadIcon}
          color="#ff9800"
          bgcolor="#fff3e0"
          subtitle="Pendientes de lectura"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <MetricCard
          label="Leídas"
          value={metrics?.read ?? 0}
          icon={ReadIcon}
          color="#4caf50"
          bgcolor="#e8f5e9"
          subtitle="Confirmadas"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <MetricCard
          label="Tasa de lectura"
          value={`${readRate}%`}
          icon={RateIcon}
          color="#9c27b0"
          bgcolor="#f3e5f5"
          helper={
            <Stack spacing={0.5} sx={{ mt: 1 }}>
              <LinearProgress
                variant={isLoading ? 'indeterminate' : 'determinate'}
                value={isLoading ? 0 : readRate}
                sx={{
                  height: 6,
                  borderRadius: 3,
                  backgroundColor: 'grey.200',
                  '& .MuiLinearProgress-bar': {
                    backgroundColor: '#9c27b0',
                    borderRadius: 3,
                  },
                }}
              />
              <Box display="flex" justifyContent="space-between">
                <Typography variant="caption" color="text.secondary">
                  {metrics?.read ?? 0} de {metrics?.total ?? 0} leídas
                </Typography>
              </Box>
            </Stack>
          }
        />
      </Grid>
    </Grid>
    </Box>
  );
};

export default MetricsBoard;
